import { render, staticRenderFns } from "./BooleanComponent.vue?vue&type=template&id=5c3d492a&scoped=true"
import script from "./BooleanComponent.vue?vue&type=script&lang=js"
export * from "./BooleanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d492a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3d492a')) {
      api.createRecord('5c3d492a', component.options)
    } else {
      api.reload('5c3d492a', component.options)
    }
    module.hot.accept("./BooleanComponent.vue?vue&type=template&id=5c3d492a&scoped=true", function () {
      api.rerender('5c3d492a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/formComponents/BooleanComponent.vue"
export default component.exports